export const validEmail = (s: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

export const validRFC = (rfc: string): boolean =>
  /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(rfc.toUpperCase().trim());

export const passwordStrength = (
  pw: string,
): { score: 0 | 1 | 2 | 3; label: string } => {
  if (pw.length < 8) return { score: 0, label: "Muy corta" };
  let s = 1;
  if (/[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  const label = ["Débil", "Aceptable", "Buena", "Fuerte"][Math.min(3, s - 1)];
  return { score: Math.min(3, s - 1) as 0 | 1 | 2 | 3, label };
};

export const money = (n: number | string): string => {
  const v = typeof n === "string" ? parseFloat(n) : n;
  return "$" + Math.round(v).toLocaleString("en-US");
};
